import { useQuery } from '@tanstack/react-query'

import { getWorkosDirectoryStatus } from '@/api/internal'

export const workosDirectoryStatusQueryKey = (enterpriseId: string) => ['workosDirectoryStatus', enterpriseId]

export const useWorkosDirectoryStatus = (enterpriseId: string) =>
  useQuery({
    queryKey: workosDirectoryStatusQueryKey(enterpriseId),
    queryFn: () => getWorkosDirectoryStatus(enterpriseId),
    retry: 1,
    staleTime: 5 * 60 * 1000,
  })
